var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesloft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 74,
    viewBox: "0 0 58 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6836 67.3373C45.6836 64.0134 48.2383 61.1523 51.7967 61.1523C55.3563 61.1523 58.001 64.0134 58.001 67.3373C58.001 70.6611 55.4467 73.5222 51.8882 73.5222C48.3289 73.5222 45.6836 70.6611 45.6836 67.3373Z",
    fill: "#B3D334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6413 14.8204C12.6413 9.8578 17.272 5.89401 23.2114 5.89401C30.9633 5.89401 35.5094 9.56083 38.1278 28.3004H39.739L42.1545 2.73675C25.0397 -3.37357 3.59581 2.94116 3.29323 21.3757C3.29323 41.2359 34.561 41.2248 34.561 59.3653C34.561 64.6612 29.9292 68.3274 24.6954 68.3274C10.8937 68.3274 7.62246 56.6157 6.91785 44.3931H5.20608L0.675781 67.4103C0.675781 67.4103 10.9444 73.522 22.0192 73.522C35.3083 73.3186 44.1677 63.4384 44.3688 53.0506C44.3688 33.0888 12.6402 28.978 12.6402 14.8213L12.6413 14.8204Z",
    fill: "#02524B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesloft);
export default __webpack_public_path__ + "static/media/salesloft.807061e5048f423351a59867a7668d3d.svg";
export { ForwardRef as ReactComponent };